var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-progress-bar"},[_c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"active-progress-line",style:({width: `${_vm.percent}%`})})]),_c('div',{staticClass:"percent-text"},[_vm._v(_vm._s(_vm.percent)+" %")])])
}
var staticRenderFns = []

export { render, staticRenderFns }